import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectOption } from '@app/interfaces/sys/dict';

@Component({
    selector: 'app-form-input',
    templateUrl: './form-input.component.html',
    styleUrls: ['./form-input.component.less'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FormInputComponent),
            multi: true,
        },
    ],
})
export class FormInputComponent implements OnInit, ControlValueAccessor {
    @Input() placeholder = '';
    @Input() readonly = false;
    @Input() canEdit = true;
    @Input() type = 'input';
    @Input() text = '';
    @Input() selectOptions: SelectOption[] = [];
    @Input() min = 0;
    @Input() nzShowArrow = false;
    @Input() nzAllowClear = false;
    @Output() changeModel = new EventEmitter();
    @Input() formControlName = '';

    value = '';
    onChange: any = () => {
    };
    onTouch: () => void = () => null;

    constructor() {
    }

    ngOnInit(): void {
    }


    writeValue(obj: any): void {
        console.log('writeValue', obj);
        this.value = obj;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    changeValue(): void {
        this.onChange(this.value);
        this.changeModel.emit();
    }
}
